import isSxSDisplayed from './isSxSDisplayed';
import AttachmentPreviewMode from '../store/schema/AttachmentPreviewMode';
import { EditMode } from '../store/schema/SxSEditState';
import getOrCreateSxSStoreData from '../store/Store';
import { logUsage } from 'owa-analytics';
import { TypeOfAttachment } from 'owa-attachment-type';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { ClientAttachmentId, isClientAttachmentIdEqual } from 'owa-client-ids';
import { trace } from 'owa-trace';
import type { WacPreviewState } from 'owa-sxsdata';
import { isFeatureEnabled } from 'owa-feature-flags';

const halfSecond = 500;

// TODO VSO 56596 - remove all parameters besides attachmentId after investigation
function isCloudyAndEditable(
    attachmentId: ClientAttachmentId,
    composeId: string,
    isInitialized: boolean,
    isReadOnly: boolean,
    isGroup: boolean,
    sxsId: string
): boolean {
    const attachmentModel = getAttachment(attachmentId);
    if (attachmentModel && attachmentModel.type === TypeOfAttachment.Reference) {
        if (isFeatureEnabled('doc-SxS-jsApi-ODB-BaseNoEditString')) {
            // This is a hack. We like to know the metrics moves without any visual indication that the file is in process of editing.
            return false;
        }
        const wacPreviewState = getOrCreateSxSStoreData(sxsId).viewState
            .previewPane as WacPreviewState;
        return wacPreviewState && wacPreviewState.readOnly === false;
    }
    if (!attachmentModel) {
        const attId: string = attachmentId ? attachmentId.Id : 'UNDEFINED';
        trace.warn('AttachmentModel not found in getAttachmentPreviewMode');
        logUsage(
            'AttchmentModelMissingInRenderAttachmentWell',
            {
                attachmentId: attId,
                composeId: composeId,
                isInitialized: isInitialized,
                isReadOnly: isReadOnly,
                isGroup: isGroup,
            },
            { isCore: true /* this datapoint is for investigating a component error */ }
        );
    }
    return false;
}

// TODO VSO 56596 - remove all parameters besides attachmentId after investigation
export default function getAttachmentPreviewMode(
    attachmentId: ClientAttachmentId,
    composeId: string,
    isInitialized: boolean,
    isReadOnly: boolean,
    isGroup: boolean,
    sxsId: string
): AttachmentPreviewMode {
    const sxsStore = getOrCreateSxSStoreData(sxsId);
    if (
        sxsStore.pendingNavigation &&
        isClientAttachmentIdEqual(sxsStore.pendingNavigation.toAttachmentId, attachmentId) &&
        sxsStore.pendingNavigation.triggerTime + halfSecond >= new Date().getTime()
    ) {
        return AttachmentPreviewMode.PendingNavigation;
    }
    if (!isSxSDisplayed(sxsId)) {
        return AttachmentPreviewMode.None;
    }
    const currentPreviewAttachmentId = sxsStore.extendedViewState.attachmentId;
    const pendingPreviewAttachmentId = sxsStore.pendingPreviewOperation?.attachmentId;

    if (isClientAttachmentIdEqual(currentPreviewAttachmentId, attachmentId)) {
        if (
            sxsStore.editState.mode === EditMode.View ||
            sxsStore.editState.mode === EditMode.EnteringEdit
        ) {
            if (
                isCloudyAndEditable(
                    attachmentId,
                    composeId,
                    isInitialized,
                    isReadOnly,
                    isGroup,
                    sxsId
                )
            ) {
                return AttachmentPreviewMode.Edit;
            }
            return AttachmentPreviewMode.Selected;
        } else if (sxsStore.editState.mode === EditMode.Saving) {
            if (isClientAttachmentIdEqual(pendingPreviewAttachmentId, attachmentId)) {
                return AttachmentPreviewMode.SelectedAndSaving;
            } else {
                return AttachmentPreviewMode.NotSelectedAndSaving;
            }
        } else {
            // Edit
            return AttachmentPreviewMode.Edit;
        }
    } else if (isClientAttachmentIdEqual(pendingPreviewAttachmentId, attachmentId)) {
        return AttachmentPreviewMode.SelectedAndPending;
    }

    return AttachmentPreviewMode.None;
}
